import { render, staticRenderFns } from "./DomainAvailableList.vue?vue&type=template&id=a77d9d90&lang=pug"
import script from "./DomainAvailableList.vue?vue&type=script&lang=js"
export * from "./DomainAvailableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports